import * as React from 'react';
import {toast as reactToast} from 'react-toastify';

import {emptyObject} from '@packages/utilities/fp/utils';

import {ToastBody} from './ToastBody';
import {ToastOptions, ToastType} from './_types';

/**
 * A facade function for creating a toast notification using react-toastify by type
 */
const createToastFacade =
  (type: ToastType) =>
  (
    message: string | React.ReactNode,
    {
      actions,
      autoClose: autoCloseProp = 5000,
      draggable: draggableProp = true,
      hasIcon = true,
      icon,
      isInline,
      onClose,
      position = 'top-right',
      role: roleProp,
      title,
      toastId,
      ...rest
    }: ToastOptions = emptyObject
  ) => {
    const autoClose = actions?.length ? false : autoCloseProp;
    const closeOnClick = draggableProp && !actions?.length;
    const draggable = draggableProp && !actions?.length;
    const role =
      roleProp ??
      (type === 'danger' || type === 'warning' ? 'alert' : 'status');

    return reactToast(
      <ToastBody
        actions={actions}
        data-automation-id="toast-notification"
        hasIcon={hasIcon}
        icon={icon}
        isInline={isInline}
        onClose={onClose}
        title={title}
        type={type}
        {...rest}
      >
        {message}
      </ToastBody>,
      {
        autoClose,
        closeOnClick,
        draggable: 'touch',
        position,
        role,
        toastId,
        className: draggable ? 'toast-draggable' : undefined,
        hideProgressBar: true,
      }
    );
  };

export {createToastFacade};
